var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 9.25a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 1 3 0v9.75a1.5 1.5 0 0 0 3 0v-12a1.5 1.5 0 0 1 3 0v9.75a1.5 1.5 0 1 0 3 0v-3a1.5 1.5 0 0 1 1.5-1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLevel);
export default __webpack_public_path__ + "static/media/water_level.6c6de11487d4268e8dd669cea02c6fc6.svg";
export { ForwardRef as ReactComponent };